<template>
  <div
    class="modal fade"
    id="waveStatusModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.WVS000 }}</b>
          </h4>
          <label v-if="elementId" class="control-label nopadding"
            >ID: {{ elementId }}</label
          >
        </div>
        <div class="modal-body">
          <div class="wave-status-modal-content">
            <table class="table">
              <thead>
                <tr>
                  <th class="nopadding noborder" style="width: 30%"></th>
                  <th class="nopadding noborder" style="width: 70%"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="
                    statusData.SurveyInstances &&
                    statusData.SurveyInstances.Status
                  "
                >
                  <td class="text-left noborder">
                    <b>{{ lang.WVS001 }}</b>
                  </td>
                  <td class="text-left noborder">
                    <table class="table table-hover" style="width: 66.67%">
                      <tbody>
                        <tr>
                          <td>{{ lang.WVS002 }}</td>
                          <td>{{ statusData.SurveyInstances.Status.Count }}</td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS003 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.Approval }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS004 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.InProgress }}
                          </td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS005 }}</td>
                          <td>
                            {{ statusData.SurveyInstances.Status.Reporting }}
                          </td>
                        </tr>
                        <tr v-if="statusData.Wave">
                          <td>{{ lang.WVS006 }}</td>
                          <td>
                            {{
                              Number((statusData.Wave.InTime * 100).toFixed(2))
                            }}
                            %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.Approvals">
                  <td class="text-left">
                    <b>{{ lang.WVS007 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover" style="width: 66.67%">
                      <tbody>
                        <tr>
                          <td>{{ lang.WVS008 }}</td>
                          <td>{{ statusData.Approvals.WithoutProposals }}</td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS009 }}</td>
                          <td>{{ statusData.Approvals.WithProposals }}</td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS010 }}</td>
                          <td>{{ statusData.Approvals.Approved }}</td>
                        </tr>
                        <tr>
                          <td>{{ lang.WVS011 }}</td>
                          <td>{{ statusData.Approvals.Rejected }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.CarDistribution">
                  <td class="text-left">
                    <b>{{ lang.WVS012 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.WVS013 }}</th>
                          <th>{{ lang.WVS014 }}</th>
                          <th>{{ lang.WVS015 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(model, index) in statusData.CarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CarModelName }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr v-if="statusData.CompetitorCarDistribution">
                  <td class="text-left">
                    <b>{{ lang.WVS018 }}</b>
                  </td>
                  <td class="text-left">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>{{ lang.WVS013 }}</th>
                          <th>{{ lang.WVS014 }}</th>
                          <th>{{ lang.WVS015 }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(model,
                          index) in statusData.CompetitorCarDistribution"
                          :key="index"
                        >
                          <td>{{ model.CompetitorCarModel }}</td>
                          <td>
                            {{ Number((model.SetValue * 100).toFixed(2)) }} %
                          </td>
                          <td>
                            {{ Number((model.ActualValue * 100).toFixed(2)) }} %
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.WVS016 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaveStatusModal",
  data() {
    return {
      elementId: 0,
      statusData: {},
      lang: {
        WVS000: "Wave Status",
        WVS001: "Check Status",
        WVS002: "Total check count",
        WVS003: "In approval",
        WVS004: "In progress",
        WVS005: "In reporting",
        WVS006: "In time",
        WVS007: "Approvals",
        WVS008: "Without proposals",
        WVS009: "With proposals",
        WVS010: "Approved",
        WVS011: "Rejected",
        WVS012: "Audi Cars",
        WVS013: "Model",
        WVS014: "Target value",
        WVS015: "Current value",
        WVS016: "Close",
        WVS017: "Wave status request failed",
        WVS018: "Competitor cars",
      },
    };
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.$off("showWaveStatus");
    this.globals.$on("showWaveStatus", (config) => {
      this.getWaveStatus(config);
    });
  },
  methods: {
    openModal() {
      $("#waveStatusModal").modal("show");
    },
    closeModal() {
      $("#waveStatusModal").modal("hide");
    },
    getWaveStatus(config) {
      if (!config) return;
      let query = `api/ProjectWaves/${config.guid}/Status`;
      this.elementId = config.id;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          if (data) this.statusData = data;
          this.openModal();
        },
        error: (error) => {
          console.error("Error on GET in getWaveStatus()");
          this.globals.showErrorSnackbar(this.lang.WVS017);
        },
      });
    },
  },
};
</script>

<style scoped>
.table {
  border: 3px solid lightgray;
  border-radius: 10px;
  border-collapse: separate;
  overflow: hidden;
}
.table th,
.table td {
  padding: 5px;
}

.wave-status-modal-content {
  max-height: calc(100vh - 215px);
  overflow: auto;
}
.noborder {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// WaveStatusModal.vue?71af0b5e